import type { TravelerId, VoteTally, VoteValue } from "../types";

interface Props {
  targetId: string;
  tally?: VoteTally;
  voterId: TravelerId;
  onVote: (targetId: string, travelerId: TravelerId, value: VoteValue | null) => void;
  compact?: boolean;
}

/** One thumb pair for the logged-in voter. The other traveler's controls stay hidden. */
export function VoteButtons({ targetId, tally, voterId, onVote, compact = false }: Props) {
  const val = tally?.[voterId];

  const toggle = (next: VoteValue) => {
    onVote(targetId, voterId, val === next ? null : next);
  };

  return (
    <div className={`vote-buttons${compact ? " compact" : ""}`} aria-label="Your vote">
      <span className="vote-person">
        <button
          type="button"
          className={val === 1 ? "active up" : ""}
          aria-pressed={val === 1}
          aria-label="Upvote"
          onClick={() => toggle(1)}
        >
          👍
        </button>
        <button
          type="button"
          className={val === -1 ? "active down" : ""}
          aria-pressed={val === -1}
          aria-label="Downvote"
          onClick={() => toggle(-1)}
        >
          👎
        </button>
      </span>
    </div>
  );
}
